import {
  MotionBox as Box,
  MotionGrid as Grid,
  MotionImage as Image,
  appearBelow,
  appearRight,
} from "utils/motion";
import Text from "components/base/Text";
import DataBlock from "components/blocks/DataBlock";
import Trans from "components/base/Trans";
import Container from "components/base/Container";

const quickStaggerVariants = {
  visible: { transition: { staggerChildren: 0.15 } },
};

export default function DataGridSection({ inverted }) {
  return (
    <Box width="100%" bg={inverted ? "black.900" : "white"}>
      <Container centerContent>
        <Grid
          variants={quickStaggerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.4 }}
          width="100%"
          templateColumns={["1fr 1fr", "1fr 1fr", null, "1fr 0.5fr 0.5fr"]}
          gap={[4, 4, 4, 4, 8]}
          justifyContent="start"
          alignItems="stretch"
        >
          <Box
            alignSelf="start"
            gridColumnStart={1}
            gridColumnEnd={[3, 3, null, 2]}
          >
            <Text
              type="headline_md"
              variants={appearRight}
              color={inverted ? "white" : "black.900"}
            >
              <Trans id="LBL_ENGINE_GT50_UNRIVALLED" />
            </Text>
            <Text
              type="headline_md"
              variants={appearRight}
              color={inverted ? "white" : "black.900"}
            >
              <Trans id="LBL_ENGINE_GT50_PERFORMANCE" />
            </Text>
          </Box>
          <DataBlock
            variants={appearBelow}
            number="400"
            unit={<Trans id="LBL_ENGINE_GT50_PERFORMANCE_UNIT_1" />}
            label={<Trans id="LBL_ENGINE_GT50_PERFORMANCE_TITLE_1" />}
            inverted
          />
          <DataBlock
            variants={appearBelow}
            number="440"
            unit={<Trans id="LBL_ENGINE_GT50_PERFORMANCE_UNIT_2" />}
            label={<Trans id="LBL_ENGINE_GT50_PERFORMANCE_TITLE_2" />}
            inverted
          />

          <Image
            variants={appearRight}
            src="/images/logo-gt50.png"
            pr={[0, 0, null, 24]}
            maxWidth={["180px", "180px", null, "460px"]}
            gridColumnStart={1}
            gridColumnEnd={[3, 3, null, 2]}
            gridRow={["1 / 2", "1 / 2", null, "auto"]}
            alignSelf="center"
          />

          <DataBlock
            variants={appearBelow}
            number="500"
            unit={<Trans id="LBL_ENGINE_GT50_PERFORMANCE_UNIT_3" />}
            label={<Trans id="LBL_ENGINE_GT50_PERFORMANCE_TITLE_3" />}
            inverted
          />
          <DataBlock
            variants={appearBelow}
            number="35"
            unit={<Trans id="LBL_ENGINE_GT50_PERFORMANCE_UNIT_4" />}
            label={<Trans id="LBL_ENGINE_GT50_PERFORMANCE_TITLE_4" />}
            inverted
          />
        </Grid>
      </Container>
    </Box>
  );
}
